import React, { useEffect, useMemo, useState } from 'react';
import { Card, Checkbox, notification, Row } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { useQuery } from 'react-query';
import {
  getThirdPartyAuthorizationListByTpid,
  updateThirdPartyAuthorizationStatus,
} from 'services/thirdParty';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import PropList from 'pages/ProposalV3/PropList';
import { toCurrency, toRate } from 'utils/utils';
import { SwapOutlined } from '@ant-design/icons';
import ButtonOperation from 'components/ButtonOperation';
import GetLabel from 'DisplayFramework/components/GetLabel';
import TpAuthorizationDetailRules from 'pages/ThirdParty/TpAuthorizationDetailRules';
import ModalControllerNV from 'components/ModalControllerNV';

export type SpouseProps = {
  form?: FormInstance;
  tpid: number;
  refetchTab?: boolean;
  isActive?: boolean;
};
const TabTPAuthorization = (props: SpouseProps) => {
  const { tpid, refetchTab,isActive } = props;

  const [TpAuthDetail, setTpAuthDetail] = useState<any[]>();

  const [tpAuthId, setTpAuthId] = useState<number>(0);
  const [tpauthdetailid, setTpauthdetailid] = useState<number>(0);

  const { data, refetch } = useQuery(
    ['getThirdPartyAuthorizationListByTpid', { tpid: Number(tpid) }],
    () =>
      getThirdPartyAuthorizationListByTpid({ tpid: Number(tpid) }).then(
        (res) => res.list || []
      ),
    { enabled: !!tpid && isActive !== false }
  );

  useEffect(() => {
    refetch();
    if (data) {
      setTpAuthDetail(data[0]?.authDetail ?? []);
    }
  }, [data, refetchTab]);
  const [delet, setdelet] = useState<boolean>(false);
  const columnsTpAuthList = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        dataIndex: 'authid',
        width: 60,
        fixed: 'left',
      },
      {
        dataIndex: 'authtypelabel',
        width: 180,
        render: (value, record) => (
          <a
            onClick={() => {
              setTpAuthId(record?.authid);
              setTpauthdetailid(0);
              setTpAuthDetail(record?.authDetail);
              setdelet(false);
            }}
          >
            {value}
          </a>
        ),
        fixed: 'left',
      },
      {
        dataIndex: 'authcalculatedamount',
        width: 120,
        render: (val, record) =>
          toCurrency(
            val,
            record.currcode ?? localStorage.getItem('currcode') ?? ''
          ),
      },
      {
        dataIndex: 'authamount',
        width: 120,
        render: (val, record) =>
          toCurrency(
            val,
            record.currcode ?? localStorage.getItem('currcode') ?? ''
          ),
      },
      {
        dataIndex: 'authbookedamount',
        width: 120,
        render: (val, record) =>
          toCurrency(
            val,
            record.currcode ?? localStorage.getItem('currcode') ?? ''
          ),
      },
      {
        dataIndex: 'authusedamount',
        width: 120,
        render: (val, record) =>
          toCurrency(
            val,
            record.currcode ?? localStorage.getItem('currcode') ?? ''
          ),
      },
      {
        dataIndex: 'authavailableamount',
        width: 120,
        render: (val, record) =>
          toCurrency(
            val,
            record.currcode ?? localStorage.getItem('currcode') ?? ''
          ),
      },
      { dataIndex: 'startdate', width: 120 },
      { dataIndex: 'enddate', width: 120 },
      
      {
        dataIndex: 'authtolerance',
        width: 120,
        render: (val, record) =>
          toRate(val),
      },
      {
        dataIndex: 'authusedamountalert',
        render: (val, record) =>
          toRate(val),
        width: 120,
      },
      {
        dataIndex: 'authflagtransfer',
        render: (val, record) =>
          <Checkbox checked={val} disabled></Checkbox>,
        width: 120,
      },
      { dataIndex: 'authstatuslabel', width: 120 },

      {
        dataIndex: 'action',
        width: 120,
        fixed: 'right',
        render: (value, record) =>
          tpAuthId === record.authid &&
          delet === true &&
          record.authstatus === 'ACTIVE' && (
            <ButtonOperation
              size="middle"
              comcode="cancel"
              icon={<SwapOutlined />}
              onClick={() => {
                updateThirdPartyAuthorizationStatus({
                  tpid: record?.tpid,
                  status: 'CANCEL',
                  authid: record?.authid,
                }).then((res) => {
                  refetch();
                  notification.success({
                    message: res.message,
                  });
                });
              }}
            />
          ),
      },
    ],
    [data, delet]
  );

  const columnsTpAuthDetail = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        dataIndex: 'authdetailid',
        width: 60,
        fixed: 'left',
      },
      {
        dataIndex: 'prcodelabel',
        render: (value, record) => (
          <a onClick={() => setTpauthdetailid(record?.authdetailid)}>{value}</a>
        ),
        width: 120,
        fixed: 'left',
      },
      { dataIndex: 'offerlabel', width: 180, fixed: 'left', },
      { dataIndex: 'ofridlabel', width: 120 },
      { dataIndex: 'ofrtypelabel', width: 120 },
      { dataIndex: 'tpname', width: 120 },
      {
        dataIndex: 'authdetailamount',
        width: 120,
        render: (val, record) =>
          toCurrency(
            val,
            record.currcode ?? localStorage.getItem('currcode') ?? ''
          ),
      },
      {
        dataIndex: 'authdetailavailableamount',
        width: 120,
        render: (val, record) =>
          toCurrency(
            val,
            record.currcode ?? localStorage.getItem('currcode') ?? ''
          ),
      },
      {
        dataIndex: 'authdetailbookedamount',
        width: 120,
        render: (val, record) =>
          toCurrency(
            val,
            record.currcode ?? localStorage.getItem('currcode') ?? ''
          ),
      },
      {
        dataIndex: 'authdetailusedamount',
        width: 120,
        render: (val, record) =>
          toCurrency(
            val,
            record.currcode ?? localStorage.getItem('currcode') ?? ''
          ),
      },
      { dataIndex: 'startdate', width: 120 },
      { dataIndex: 'enddate', width: 120 },   
      
      {
        dataIndex: 'authtolerance',
        render: (val, record) =>
          toRate(val),
        width: 120,
      }, 
      {
        dataIndex: 'authusedamountalert',
        width: 120,
        render: (val, record) =>
          toRate(val),
      },
      {
        dataIndex: 'authriskclass',
        width: 120,
      },
      { dataIndex: 'status', width: 120 },
      {
        dataIndex: 'Rules',
        fixed: 'right',
        width: 120,
        render: (value, record) => {
          return (
            <ModalControllerNV
              modal={({ setVisible, visible }) => (
                <TpAuthorizationDetailRules
                  authdetailid={record.authdetailid}
                  currcode={
                    record?.currcode ?? localStorage.getItem('currcode')
                  }
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  data={record.tpAuthorizationDetailRules}
                  hideAction
                />
              )}
              content={({ setVisible, visible }) => (
                <a onClick={() => setVisible(true)}>
                  <GetLabel label="List of rules" />
                </a>
              )}
            />
          );
        },
      },
    ],
    [TpAuthDetail]
  );

  return (
    <Card
      title={
        <GetLabel
          label="tpauthorization"
          style={{ fontWeight: 'bold', paddingLeft: 15 }}
        />
      }
      style={{
        backgroundColor: '#f7f7f7',
        boxShadow:
          'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
      }}
      bordered
    >
      <Row gutter={16}>
        <DataGrid
          rowKey="authid"
          dataSource={data}
          columns={columnsTpAuthList}
          titleComcode="tpauthorizationList"
          hideFilters
        />
      </Row>

      <Row gutter={16} style={{ marginTop: 30 }}>
        <DataGrid
          rowKey="authdetailid"
          dataSource={TpAuthDetail}
          columns={columnsTpAuthDetail}
          titleComcode="tpauthorizationDetails"
          hideFilters
        />
      </Row>

      {(tpAuthId !== 0 || tpauthdetailid !== 0) && (
        <Row gutter={16} style={{ marginTop: 30 }}>
          <PropList
            search
            hideFilters
            hideExtraAction
            PropOrProd="PROPOSAL"
            tpauthid={tpAuthId}
            tpauthdetailid={tpauthdetailid}
            // setdelet={setdelet}
            // delet={delet}
            setdelet={setdelet}
            delet={delet}
          />
        </Row>
      )}
    </Card>
  );
};

export default TabTPAuthorization;
